/**
 * Print Advertising service page
 * Converted blue button accents to orange
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { FileText, CheckCircle } from 'lucide-react'

export default function PrintAdvertisingPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-yellow-900 via-yellow-800 to-orange-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Print Advertising</h1>
              <p className="text-xl text-yellow-100 leading-relaxed mb-8">
                Strategic newspaper and magazine campaigns with creative design and premium 
                placements to reach your target audience through trusted print media.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Launch Print Campaign</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/a1c171bc-3e2d-4beb-9fd4-be784e228b6a.jpg" 
                alt="Print Advertising"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Print Campaign Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Creative Design</h3>
                    <p className="text-gray-600">Eye-catching print advertisements that stand out</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Media Planning</h3>
                    <p className="text-gray-600">Strategic selection of newspapers and magazines</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Premium Placements</h3>
                    <p className="text-gray-600">Front page, back cover, and prime positioning</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Campaign Tracking</h3>
                    <p className="text-gray-600">Comprehensive campaign reporting and delivery summaries</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Print Proofs</h3>
                    <p className="text-gray-600">Final proofs, color checks, and print-ready files</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/a50f19ec-78b3-434b-9da0-0cbc83fa1c18.jpg" 
                alt="Magazine Advertising"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-yellow-900 to-orange-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Make an Impression?</h2>
          <p className="text-xl text-yellow-100 mb-8">
            Let us create powerful print campaigns that capture attention and drive results
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Start Print Campaign</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
